import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Rocket, ExternalLink } from "lucide-react";

export const ProjectDialog = ({ project, onClose }) => {
  return (
    <Dialog open={!!project} onOpenChange={onClose}>
      <DialogContent className="rounded-2xl border border-rose-500/30 bg-[hsl(var(--card))] max-w-3xl shadow-2xl" data-testid="project-dialog">
        {project && (
          <>
            <DialogHeader>
              <div className="h-1 w-full bg-gradient-to-r from-rose-500 via-purple-500 to-rose-500 rounded-t-2xl -mt-6 -mx-6 mb-4" />
              <DialogTitle className="font-display text-3xl font-bold text-rose-200" data-testid="project-dialog-title">
                {project.title}
              </DialogTitle>
              <DialogDescription className="text-base text-[hsl(var(--muted-foreground))] leading-relaxed mt-2" data-testid="project-dialog-description">
                {project.details}
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-6 mt-6">
              <div className="flex flex-wrap gap-2">
                {project.tags.map((tag) => (
                  <Badge
                    key={tag}
                    className="rounded-lg border border-rose-500/30 bg-rose-500/10 text-rose-300 font-mono text-xs px-3 py-1.5"
                    data-testid="project-dialog-tag"
                  >
                    {tag}
                  </Badge>
                ))}
              </div>

              {project.subStores && (
                <div className="border-t border-[hsl(var(--border))] pt-6">
                  <h4 className="font-semibold text-lg mb-4 text-[hsl(var(--foreground))]">
                    Four Specialized Departments:
                  </h4>
                  <div className="grid sm:grid-cols-2 gap-3">
                    {project.subStores.map((subStore) => (
                      <a
                        key={subStore.url}
                        href={subStore.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-start gap-3 p-3 rounded-lg border border-[hsl(var(--border))] bg-[hsl(var(--muted))]/30 hover:border-rose-500/30 hover:bg-rose-500/5 transition-all group"
                      >
                        <ExternalLink className="w-4 h-4 text-[hsl(var(--primary))] mt-0.5 group-hover:text-rose-400 transition-colors" />
                        <div className="flex-1 min-w-0">
                          <p className="font-semibold text-sm text-[hsl(var(--foreground))] group-hover:text-rose-300 transition-colors">
                            {subStore.name}
                          </p>
                          <p className="text-xs text-[hsl(var(--muted-foreground))] mt-0.5">
                            {subStore.description}
                          </p>
                        </div>
                      </a>
                    ))}
                  </div>
                </div>
              )}

              <div className="flex items-center gap-2 pt-4">
                <div className="flex items-center gap-2 px-4 py-2 bg-rose-500/10 border border-rose-500/20 rounded-lg">
                  <div className="w-2 h-2 bg-rose-500 rounded-full animate-pulse" />
                  <span className="font-mono text-sm font-semibold text-rose-500">{project.coins} Points</span>
                </div>
              </div>

              <div className="flex gap-4 pt-4">
                <Button
                  asChild
                  className="modern-button rounded-xl bg-gradient-to-r from-rose-500 to-purple-500 text-white hover:from-rose-600 hover:to-purple-600 font-semibold text-base px-8 py-6 shadow-lg glow flex-1"
                  data-testid="project-dialog-visit-btn"
                >
                  <a href={project.link} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2">
                    <Rocket className="w-5 h-5" />
                    Visit Main Store
                  </a>
                </Button>
              </div>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
